import { SVGProps } from 'react';

interface Props {
  props?: SVGProps<SVGSVGElement>;
  size?: string | number;
  muted?: boolean;
}

const Development = ({ props, size = 16, muted = false }: Props) => {
  const dark = muted ? '#5d5d5d' : '#084c36';
  const light = muted ? '#6d6d6d' : '#39d08f';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path fill={dark} d="m8 11 8-11H0z" />
      <path fill={light} d="m8 5 8 11H0z" />
    </svg>
  );
};

export default Development;
